import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import RecipientSelect from './components/RecipientSelect'
// views
import { RecipientWrapper } from './views'
import { AddButton, CloseIcon } from 'components/Modals/SystemProcessModal/Form/components/views'
// types
import { IOption } from 'components/FormElements/Select'

interface RecipientsProps {
  recipientsCount: number
  riskTemplateFields: (IOption & any)[]
  parentRiskTemplatesFields: (IOption & any)[]
}

const renderRecipients: React.FC<WrappedFieldArrayProps<any> & RecipientsProps> = ({
  fields,
  recipientsCount,
  riskTemplateFields,
  parentRiskTemplatesFields
}) => {
  const addField = () => fields.push({})

  const removeField = (idx: number) => () => fields.remove(idx)

  if (!fields.length) {
    fields.push({})
  }

  return (
    <>
      {fields.map((field, idx) => (
        <RecipientWrapper key={field}>
          {/*<ReduxSelect name={`${field}.recipientType`} options={RECIPIENT_GROUPING_TYPE_OPTIONS} />*/}
          <RecipientSelect
            field={field}
            riskTemplateFields={riskTemplateFields}
            parentRiskTemplatesFields={parentRiskTemplatesFields}
          />
          {recipientsCount > 1 && <CloseIcon onClick={removeField(idx)} />}
        </RecipientWrapper>
      ))}

      <p></p>

      <AddButton onClick={addField}>+ add recipient</AddButton>
    </>
  )
}

export default renderRecipients
